import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affiliate-program',
  templateUrl: './affiliate-program.component.html',
  styleUrls: ['./affiliate-program.component.css']
})
export class AffiliateProgramComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
